import React, { useEffect, useState } from 'react'
import './Games.scss';
import axios from 'axios';
import { Link, useLocation } from "react-router-dom";
import moment from 'moment'

const Games = () => {
    // State of your application
    const location = useLocation();

    const [games, setGames] = useState([]);
    const [error, setError] = useState(null);
    let currentUrlId = Number(location.pathname.split('/')[2]);
    var isoDate = new Date().toISOString()
    useEffect(() => {
        async function fetchGame() {
            try {
                await axios.get(`https://admin.capncovers.com/api/games?filters[date][$gte]=${isoDate}&sort=date:ASC`)
                    .then((response) => setGames(response.data.data));
                console.log(isoDate)
            } catch (error) {
                setError(error)
            }
        }
        fetchGame();

    }, [])
    // Print errors if any
    if (error) {
        return <div>An error occured: {error.message}</div>;
    }
    return (
        <div className='games'>
            <h1 className='subHeader'>Upcoming Games</h1>

            {games.map((item, index) => (
                <div key={index}>
                    <Link to={`/games/${item.id}`} style={{ textDecoration: 'none' }}>
                        <div className={item.id === currentUrlId ? "active gameCard" : "gameCard"}>
                            <h3>
                                {
                                    moment(item.attributes.date).format("dddd")
                                }  at {moment(item.attributes.date).format("h:mma")}</h3>
                            <h2 className='gameName'>{item.attributes.title}</h2>
                            <h4>{item.attributes.sport}</h4>
                        </div>
                    </Link>
                </div>
            ))}
        </div>
    )
}

export default Games;
